// PrintPage.js
// adapated from OverallStudyResultsPage.js

import React, { Component } from 'react';
//import Modal from '../components/Modal.js';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { observer } from 'mobx-react';

import helpers from '../util/helpers';

type Props = {
  intl: Object
}

class PrintPage extends React.Component<Props> {
    constructor() {
      super();
      this.state = {
        modals: [false, false, false, false]
      };
    }

    onClickPrint(e) {
        /// OLD method 1 -- simple get link
        /// <a href='#' className="button" onClick={this.onClickPrint.bind(this)}><FormattedMessage id='download' defaultMessage='Download' /></a>
        ///e.preventDefault();

        helpers.eventLog("nav:print download button pressed - PrintPage.onClickPrint()");
        return true;

        ///const av = window.localStorage.getItem('avatar');
        ///const la = window.localStorage.getItem('language');
    }

    render() {

        const av = window.localStorage.getItem('avatar') || 'face-1';
        const la = window.localStorage.getItem('language') || 'es';
        ///const ac = window.localStorage.getItem('access_code'); // OLD method 2
        /// <!-- <input type="hidden" name="access_code" value={ac} /> -->

        // method 3 -- devisetokenauth accepts token vals as headers OR params
        const token_at = window.localStorage.getItem('access-token');
        const token_client = window.localStorage.getItem('client');
        const token_uid = window.localStorage.getItem('uid');
        const token_expiry = window.localStorage.getItem('expiry');

        const buttontext = this.props.intl.messages["download"];

        return (
            <div className="page print-page">
                <h2>
                <FormattedMessage id='page.print_page.title' defaultMessage='Print' />
                </h2>

                <FormattedHTMLMessage id='page.print_page.content' defaultMessage='code=pp1' />

                <br />

                <form action={`https://ikids-admin.reportback.org/pdfmerge?avatar=${av}&language=${la}`} target="_blank" method="post">

                    <input type="hidden" name="access-token" value={token_at} />
                    <input type="hidden" name="client" value={token_client} />
                    <input type="hidden" name="uid" value={token_uid} />
                    <input type="hidden" name="expiry" value={token_expiry} />

                    <input className="button" type="submit" value={buttontext} onClick={this.onClickPrint.bind(this)} />
                </form>

                <p>
                    <br />
                </p>

            </div>

        )
    } // end render

} // end PrintPage

//export default injectIntl(PrintPage);
export default injectIntl(observer(PrintPage));



// WEBPACK FOOTER //
// ./src/pages/PrintPage.js